// removed by extract-text-webpack-plugin
module.exports = {"address-book-modal":"_1YPteSwF3vEQLTwKkeHC6s","address-book-blackout":"_3Gk8XrMkfJzAGUFA_kLBEL","close-on-click":"_1DzX-ObcHX4PH3c2RPXQjD","close-link":"_2wovE0X4m00Q-gi_MPXqBY"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/style.scss
// module id = 926
// module chunks = 0